import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Job marked complete", { props: { triggerType: "Pipeline Stage Changed", event: "Jobs → Completed" } }],
  ["w1", "auto-wait", "Wait 4 hours", { props: { duration: "4", unit: "hours" } }],
  ["s1", "auto-sms", "How did we do? 1-5", { props: { message: "Hi {{contact.first_name}} — how did we do today? Reply 1-5." } }],
  ["c1", "auto-condition", "Scored 4 or 5?", { props: { condition: "job_rating is greater than 3" } }],
  ["e1", "auto-email", "Leave a public review", { props: { subject: "Would you mind saying that publicly?" } }],
  ["k1", "auto-task", "Call anyone who scored 1-3", { props: { assignee: "Owner", due: "+1 day" } }],
  ["w2", "auto-wait", "Wait 7 days", { props: { duration: "7", unit: "days" } }],
  ["e2", "auto-email", "Refer a neighbour, both get $50", { props: { subject: "Know someone who needs this?" } }],
  ["tg", "auto-tag-add", "Tag: referral-invited", { props: { tag: "referral-invited" } }],
]);

const def: TemplateDef = {
  slug: "review-referral-engine",
  name: "Review & Referral Engine",
  category: "Services",
  tagline:
    "Ask privately, publish the good ones, and turn happy jobs into the next two.",
  description:
    "A free review and referral template: four hours after a job completes, a rating text goes out privately, high scores are routed to your public review page, low scores reach a human, and a week later everyone gets a referral offer. Clone it into FrazzleCRM and run it off your pipeline.",
  whatsInside: [
    "Pipeline-stage trigger so completion drives the ask, not a person",
    "Private 1-5 rating SMS before any public review request",
    "Score branch: review page for promoters, a call task for detractors",
    "A referral offer seven days later, tagged so nobody gets it twice",
  ],
  flow: makeFlow(
    [
      node("jb", "outcome-won", "Job completed", 40, 140, { props: { value: "$2,400" } }),
      flow("f1", "Review & Referral", 360, 40, 420, 948),
      ...seq.nodes,
      node("rv", "page-web", "Public review page", 880, 200, { url: "https://g.page/r/your-review-link" }),
      node("rf", "page-optin", "Referral signup", 880, 380, { props: { magnet: "$50 for you, $50 for them" } }),
      node("out", "outcome-lead", "Referred lead", 1200, 290, { props: { source: "Customer referral" } }),
      node("n1", "util-note", "Never buy a bad review", 40, 340, {
        notes:
          "Asking everyone for a public review is how you collect one-stars. The private rating text is a filter: promoters get the link, everyone else gets a phone call while it is still fixable.",
      }),
    ],
    [
      edge("jb", "f1"),
      ...seq.edges,
      edge("f1", "rv"),
      edge("f1", "rf"),
      edge("rf", "out"),
    ]
  ),
};

export default def;
